import styled from "styled-components";
import { IMAGES } from "../../constants/images";

export default function ZoomControl() {
  const handleZoomIn = () => {
    const map = window.map;
    if (!map) return;

    map.zoomIn();
  };

  const handleZoomOut = () => {
    const map = window.map;
    if (!map) return;

    map.zoomOut();
  };

  return (
    <ZoomControlContainer>
      <button onClick={handleZoomIn}>
        <img src={IMAGES.PLUS} alt="Plus" />
      </button>
      <button onClick={handleZoomOut}>
        <img src={IMAGES.MINUS} alt="Minus" />
      </button>
    </ZoomControlContainer>
  );
}

const ZoomControlContainer = styled.div`
  display: grid;
  position: absolute;
  right: 20px;
  bottom: 86px;
  width: 34px;
  height: 68px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;

  button {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    cursor: pointer;
    transition: background-color 0.3s;

    img {
      width: 18px;
    }
  }

  button:hover {
    background-color: #ececec;
  }
`;
